import api from './api';

export type DriverPayAdditionVariant = 'drayage' | 'waiting' | 'default';

export interface DriverPayAdditionTypeAdmin {
  id: number;
  name: string;
  variant: DriverPayAdditionVariant;
  showsFuelType: boolean;
  gwiCommission: boolean;
  limitAmount: number;
  /** Only selectable by users whose 360 group has the manager-types endpoint. */
  managerOnly: boolean;
  description: string;
  isActive: boolean;
}

export interface DriverPayAdditionTypeCreate {
  name: string;
  variant: DriverPayAdditionVariant;
  showsFuelType: boolean;
  gwiCommission: boolean;
  limitAmount: number;
  managerOnly: boolean;
  description: string;
  isActive: boolean;
}

export type DriverPayAdditionTypePatch = Partial<DriverPayAdditionTypeCreate>;

export const driverPayAdditionTypesService = {
  async list(): Promise<DriverPayAdditionTypeAdmin[]> {
    const res = await api.get('/admin/driver-pay-addition-types');
    return res.data;
  },

  async create(payload: DriverPayAdditionTypeCreate): Promise<DriverPayAdditionTypeAdmin> {
    const res = await api.post('/admin/driver-pay-addition-types', payload);
    return res.data;
  },

  async update(id: number, patch: DriverPayAdditionTypePatch): Promise<DriverPayAdditionTypeAdmin> {
    const res = await api.put(`/admin/driver-pay-addition-types/${id}`, patch);
    return res.data;
  },

  async deactivate(id: number): Promise<void> {
    await api.delete(`/admin/driver-pay-addition-types/${id}`);
  },
};
